import GroupIcon from '@components/Icons/GroupIcon';
import IconYoutube from '@components/Icons/iconYoutube';
import { useModal } from '@components/ModalHook';
import VnrLink from '@components/VnrLink';
import { createMultiUserMeta } from "@services/userMeta.service.js";
import { Col,Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { USER_MEATA_KEY } from 'src/constants';

import Modal from "./Modal";
import styles from "./PopupAcademy.module.scss";

export const MODAL_ID = 'POPUP_ACADEMY_EBOOK';

const PopupAcademyEbook = ({userId, setIsEligibleToDownloadEbook}) => {
  const [modalData, , hideModal] = useModal(MODAL_ID);
  const [isJoinedChannel, setIsJoinedChannel] = useState(false);
  const [isJoinedGroupChat, setIsJoinedGroupChat] = useState(false);
  const [isJoinedYoutube, setIsJoinedYoutube] = useState(false);
  const [isEligibleToDownload, setIsEligibleToDownload] = useState(false);

  let isShow = modalData.data?.isShow;
  let isEligible = modalData.data?.isEligible;
  let data =  modalData.data?.content;
  
  const createSubcribeSocialUserMeta = (type) => {
    if (type === 'telegramChannel' && !isJoinedChannel) {
      createMultiUserMeta([{
        userId: userId,
        metaKey: USER_MEATA_KEY.IS_SUBCRIBED_TELEGRAM_CHANNEL,
        metaValue: true,
      }]);
      setIsJoinedChannel(true)
    }

    if (type === 'telegramGroupChat' && !isJoinedGroupChat) {
      createMultiUserMeta([{
        userId: userId,
        metaKey: USER_MEATA_KEY.IS_SUBCRIBED_TELEGRAM_GROUPCHAT,
        metaValue: true,
      }]);
      setIsJoinedGroupChat(true)
    }

    if (type === 'youtubeChannel' && !isJoinedYoutube) {
      createMultiUserMeta([{
        userId: userId,
        metaKey: USER_MEATA_KEY.IS_SUBCRIBED_YOUTUBE,
        metaValue: true,
      }]);
      setIsJoinedYoutube(true)
    }
  };

  useEffect(() => {
    const isUserJoinedChannel = data?.find(item => item.metaKey === "IS_SUBCRIBED_TELEGRAM_CHANNEL") ? true : false;
    if (isUserJoinedChannel) setIsJoinedChannel(true);

    const isUserJoinedGroupChat = data?.find(item => item.metaKey === "IS_SUBCRIBED_TELEGRAM_GROUPCHAT") ? true : false;
    if (isUserJoinedGroupChat) setIsJoinedGroupChat(true);

    const isUserJoinedYoutube = data?.find(item => item.metaKey === "IS_SUBCRIBED_YOUTUBE") ? true : false;
    if (isUserJoinedYoutube) setIsJoinedYoutube(true);
  }, [modalData]);

  useEffect(() => {
    if (isJoinedChannel && isJoinedGroupChat && isJoinedYoutube) {
      setIsEligibleToDownload(true);
      setIsEligibleToDownloadEbook(true);
    }
  }, [isJoinedChannel, isJoinedGroupChat, isJoinedYoutube])
  
  return (
    <Modal
      show={isShow ? true : false}
      close={hideModal}
    >
      <div className={styles["popup-perform-target-reward"]}>
        <div className={styles['content-wrapper']}>
          <Row className={styles['header']} align="middle">
            <Col className={styles['header-title']} span={24}>
              Hoàn thành yêu cầu
            </Col>
            <Col className={styles['header-requirement-text']} span={24}>
            <b>Tải miễn phí</b>:  Dành cho thành viên cộng đồng VnRebates - Nơi Trading là NGHỀ. Bạn chỉ cần Join vào group <VnrLink to="https://t.me/VnrebatesCHAT">Telegram VnRebates</VnrLink>, Subscribe kênh <VnrLink to="https://t.me/vnrebates">channel Telegram</VnrLink> và <VnrLink to="https://www.youtube.com/channel/UCpCt75O_kcHwwkW5mgf45Mw?sub_confirmation=1">Youtube</VnrLink> bên dưới.
            </Col>
          </Row>

          <div className={styles.buttonSocialWrapper}>
            <div className={styles.buttonWrapper} onClick={() => createSubcribeSocialUserMeta('telegramGroupChat')}>
              <VnrLink
                to="https://t.me/VnrebatesCHAT"
                className={styles.buttonGroupTelegram}
              >
                <GroupIcon />
                Group Chat Telegram
              </VnrLink>
            </div>
            
            <div className={styles.buttonWrapper} onClick={() => createSubcribeSocialUserMeta('telegramChannel')}>
              <VnrLink 
                to="https://t.me/vnrebates"
                className={styles.buttonChannelTelegram}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 49 48" ><path fill="#fff" d="M21.412 27.181l-.397 5.584c.568 0 .814-.244 1.11-.537l2.662-2.545 5.518 4.041c1.012.564 1.725.267 1.998-.931l3.622-16.972.001-.001c.321-1.496-.54-2.081-1.527-1.714l-21.29 8.151c-1.453.564-1.43 1.374-.247 1.741l5.443 1.693 12.643-7.911c.595-.394 1.136-.176.691.218l-10.227 9.183z"></path></svg>
                Channel Telegram
              </VnrLink>
            </div>

            <div className={styles.buttonWrapper} onClick={() => createSubcribeSocialUserMeta('youtubeChannel')}>
              <VnrLink 
                to="https://www.youtube.com/channel/UCpCt75O_kcHwwkW5mgf45Mw?sub_confirmation=1"
                className={styles.buttonYoutube}
              >
                <IconYoutube />
                Channel Youtube
              </VnrLink>
            </div>
          </div>
          
        </div>
        <div className={styles['background']}>
          <div className={styles['background-footer-logo']}>
          </div>
          <div className={styles['background-footer-right-space']}></div>
          <div className={styles['popup-perform-target-reward-footer-background']}>
            {(isEligible || isEligibleToDownload) &&
              <div className={styles.linkEbook}>
                <VnrLink to='https://agileops-gafv-dev-videos.s3.amazonaws.com/VnRebates - Price Action chuyên sâu.pdf'>
                  &#187; Tải Ebook " VnRebates  - Price Action chuyên sâu.PDF" &#171;
                </VnrLink>
              </div>
            }
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PopupAcademyEbook;